
const Apiurl = 'https://managercategory.enjoytool.net/backend';
//const Apiurl = 'http://127.0.0.1:1804';
export default Apiurl
